export { default } from './ModalRoot';


// WEBPACK FOOTER //
// ./src/components/globalModals/index.js